// extracted by mini-css-extract-plugin
export default {"PagePaginationFrame":"OrderHistory_PagePaginationFrame__Kb+lP"};